import { Link, useNavigate } from "react-router-dom";
import apiAgent from "../api/apiAgent";
import { useEffect, useState } from "react";
import { useSetAtom } from "jotai";
import { loginStatusAtom } from "../atoms";
import { tMsg } from "../components/ToastNotifications";
import { wait } from "@testing-library/user-event/dist/utils";
import { Button } from "../components/Button";

interface IRegisterUserData {
  name: string;
  email: string;
  password: string;
  user_role: "admin" | "editor";
}

const Settings = (): JSX.Element => {
  const [formData, setFormData] = useState<IRegisterUserData>({
    name: "",
    email: "",
    password: "",
    user_role: "admin",
  });
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const register = async () => {
    try {
      const response = await apiAgent.Auth.register(formData);
      if (response.status === 200) {
        tMsg.success(`User "${formData.name}" successfully added`);
      }
    } catch (err) {
      console.log(err);
      tMsg.error("Error adding new user");
    } finally {
      setFormData({
        name: "",
        email: "",
        password: "",
        user_role: "admin",
      });
      setConfirmPassword("");
    }
  };

  const handleSubmit = () => {
    if (formData.name?.length < 1) {
      tMsg.error("Please give a name");
      return;
    }
    if (formData.password?.length < 1) {
      tMsg.error("Please give a valid password");
      return;
    }
    if (confirmPassword !== formData.password) {
      tMsg.error("Passwords do not match");
      return;
    }
    register();
  };

  const updateFormData = (keyName: string, value: string) => {
    const newFormData = {
      ...formData,
      [keyName]: value,
    };
    setFormData(newFormData);
  };

  return (
    <div className="w-full h-full grid content-center bg-gray-500">
      <div className="space-y-4 flex flex-col justify-center">
        <div className="font-medium place-self-center">
          <h1 className="font-bold text-lg">Add new user</h1>
          <form>
            <div className="my-4">
              <div>Name</div>
              <input
                className="text-black p-1"
                type={"text"}
                value={formData.name}
                onChange={(e) => {
                  e.preventDefault();
                  updateFormData("name", e.target.value);
                }}
                required
              />
            </div>
            <div className="my-4">
              <div>Email</div>
              <input
                className="text-black p-1"
                type={"email"}
                value={formData.email}
                onChange={(e) => {
                  e.preventDefault();
                  updateFormData("email", e.target.value);
                }}
              />
            </div>
            <div className="my-4">
              <div>Password</div>
              <input
                className="text-black p-1"
                type={"password"}
                value={formData.password}
                onChange={(e) => {
                  e.preventDefault();
                  updateFormData("password", e.target.value);
                }}
                required
              />
            </div>
            <div className="my-4">
              <div>Confirm Password</div>
              <input
                className="text-black p-1"
                type={"password"}
                value={confirmPassword}
                onChange={(e) => {
                  e.preventDefault();
                  setConfirmPassword(e.target.value);
                }}
                required
              />
            </div>
            <Button
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Settings;
